module.exports = __webpack_public_path__ + "img/LUB00155.06b56b3b.svg";